import { withRouter } from 'react-router-dom'
import { Component } from 'react'
import { PROFILE_URL } from '../../urls'
import { RouteComponentProps } from 'react-router'

class ScrollTop extends Component {
  componentDidUpdate(prevProps: RouteComponentProps) {
    const { location, history } = this.props as RouteComponentProps
    try {
      if (history.action === 'POP') {
        return
      }
      if (
        (location.pathname !== prevProps.location.pathname &&
          (!location.pathname.includes(PROFILE_URL) || !prevProps.location.pathname.includes(PROFILE_URL))) ||
        !['PUSH', 'REPLACE'].includes(history.action)
      ) {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' })
      }
    } catch (e) {
      console.error(e.message)
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollTop as any)
